import { Reducer } from 'redux';
import { Actions } from 'store/actions/chat.action';
import {
  CHAT_LOADING,
  CHAT_LOADED,
  CHAT_LOADING_FAILED,
  CHAT_UPDATE,
} from 'store/types/chat.type';

import { RootReducerType } from './index';

export type State = {
  isLoading: boolean;
  isNext: boolean;
  page: number;
  unreadCount: number;
  error: string;
  chats: any;
};

const initialState: State = {
  chats: {},
  isLoading: false,
  isNext: true,
  page: 1,
  unreadCount: 0,
  error: '',
};

export const chatReducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_LOADING:
      return { ...state, isLoading: true, error: '', chats: action.payload ? {} : state.chats };
    case CHAT_LOADED:
      return { ...state, isLoading: false, ...action.payload };
    case CHAT_LOADING_FAILED:
      return { ...state, isLoading: false, error: action.err };

    case CHAT_UPDATE:
      return { ...state, chats: action.payload };

    default:
      return state;
  }
};

export const chatSelector = (state: RootReducerType) => state.chats;
export default chatReducer;
